@if (user) {
  <h1>{{ greeting }}, {{ user?.firstname }}</h1>
}
